// Bloodbank docs point at their department via `reference`
// (rhf/{rhfId}/hf/{hfId}/departments/{deptId}) — a Firestore
// DocumentReference when the doc is read directly, the same path as a
// string when it comes through the /v1 API (GET /v1/bloodbanks sanitizes
// references to their path). The HF (Helseforetak) id is the fourth path
// segment; null when the reference is missing or not under an HF.
export const getHfIdFromReference = (reference) => {
  const path = typeof reference === 'string' ? reference : reference?.path;
  if (!path) return null;
  const parts = path.split('/');
  return parts[2] === 'hf' && parts[3] ? parts[3] : null;
};
